import { Component, Input, NgModule, OnInit } from '@angular/core';
import { TextBlockComponent } from './text-block/text-block.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { BlockCreatorService } from '../../services/block-creator.service';
import { FormsModule, NgModel, ReactiveFormsModule } from '@angular/forms';
import { NgFor, NgIf } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';
import { Block } from '../../models/block.model';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonToggleGroup, MatButtonToggleModule } from '@angular/material/button-toggle';
import { TextBlockDetails } from '../../models/text-block-details.model';
import { MatButtonModule } from '@angular/material/button';
import { ImageBlockDetails } from '../../models/image-block-details.model';
import { BarcodeBlockDetails } from '../../models/barcode-block-details.model';

@Component({
    selector: 'app-blocks-creator',
    standalone: true,
    imports: [
        //TextBlockComponent,
        MatFormFieldModule,
        MatSelectModule,
        FormsModule,
        MatInputModule,
        MatToolbarModule,
        MatButtonToggleGroup,
        MatButtonToggleModule,
        ReactiveFormsModule,
        MatButtonModule,
        NgFor,
        NgIf
    ],
    templateUrl: './blocks-creator.component.html',
    styleUrl: './blocks-creator.component.css'
})
export class BlocksCreatorComponent implements OnInit {

  //@Input()
  rekbotID: number = 0;

  toggleGr = ['italic']
  blockText: string = "";
  textBlockValues: TextBlockDetails;
  imageBlockValues: ImageBlockDetails;
  barcodeBlockValues: BarcodeBlockDetails;


  currentBlock: Block | undefined;

  selectedBlockType: string = ""
  newBlockName: string = ""

  //rekbotID: number = 1

  blockTypes = [
    {
      value: "text",
      viewValue: "Blok tekstowy"
    },
    {
      value: "image",
      viewValue: "Blok grafiki"
    },
    {
      value: "barcode",
      viewValue: "Blok kodu kreskowego"
    }
  ]

  alignTypes = [
    {
      value: 0,
      viewValue: "0"
    },
    {
      value: 1,
      viewValue: "1"
    },
    {
      value: 2,
      viewValue: "2"
    }
  ];

  fontTypes = [
    {
      value: 1,
      viewValue: "1"
    },
    {
      value: 2,
      viewValue: "2"
    }
  ];

  fontSizes = [
    {
      value: 0,
      viewValue: "0"
    },
    {
      value: 1,
      viewValue: "1"
    },
    {
      value: 2,
      viewValue: "2"
    }
  ];

  barcodeTypes = [
    {
      value: "CODE-128",
      viewValue: "CODE-128"
    }
  ];

  imagePaths = [
    {
      value: "print1.png",
      viewValue: "print1.png"
    }
  ];

  imageAlign = [
    {
      value: 1,
      viewValue: "1"
    }
  ];


  justifications = [
    {
      value: "left",
      viewValue: "left"
    },
    {
      value: "center",
      viewValue: "center"
    },
    {
      value: "right",
      viewValue: "right"
    }
  ];



  constructor(
    public blockService: BlockCreatorService,
    public router: Router,

  ) {
    this.textBlockValues = new TextBlockDetails([], 0, 0, 0, []);
    this.imageBlockValues = new ImageBlockDetails("", 0, 0, 0);
    this.barcodeBlockValues = new BarcodeBlockDetails("{voucher-barcode}", "CODE-128", "2", 100, 2, "center");
    console.log("constructor", this.blockService.getList());
  }

  ngOnInit(): void {

    this.rekbotID = this.blockService.getRekbotId();
    this.fetchList()
     
  }

  initForm() {
    this.selectedBlockType = ""
    this.newBlockName = ""
  }

  fetchList() {
    this.blockService.fetchList(this.rekbotID)
      .subscribe({
        next: (response: any) => {
          console.log("fetch response", response)

          this.blockService.attachList(response.blocksList.map((item: any) => {
            item.blockDetails = JSON.parse(item.block_details)
            return item
          }))
        },
        error: error => {
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      })
  }


  addBlock() {
    console.log("addBlock")
    if (this.selectedBlockType.length === 0) {
      alert("wybierz typ bloku")
    } else {
      this.blockService.addBlock(this.rekbotID, this.selectedBlockType, this.newBlockName)
        .subscribe({
          next: (response: any) => {
            this.fetchList();
          },
          error: error => {
            console.log(error)
            if (error.status === 401) {
              this.router.navigate(['/']);
            }
          }
        })

      this.initForm();
    }
    console.log("block list", this.blockService.getList())
  }

  updateTextBlock() {

    if (this.textBlockValues !== undefined) {
      this.textBlockValues.textLines = this.blockText.split("\n");
      this.textBlockValues.textFormatting = this.toggleGr
    }

    this.blockService.updateBlock(this.currentBlock, this.textBlockValues)
      ?.subscribe({
        next: (response: any) => {
          this.fetchList();
        },
        error: error => {
          console.log(error)
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      })
  }

  updateImageBlock() {

    this.blockService.updateBlock(this.currentBlock, this.imageBlockValues)
      ?.subscribe({
        next: (response: any) => {
          this.fetchList();
        },
        error: error => {
          console.log(error)
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      })
  }

  updateBarcodeBlock() {
    this.blockService.updateBlock(this.currentBlock, this.barcodeBlockValues)
      ?.subscribe({
        next: (response: any) => {
          this.fetchList();
        },
        error: error => {
          console.log(error)
          if (error.status === 401) {
            this.router.navigate(['/']);
          }
        }
      })
  }


  selectBlock(selectedBlock: Block) {

    //console.log("selectBlock", selectedBlock, selectedBlock.blockDetails)
    this.currentBlock = selectedBlock


    if (selectedBlock.type === 'text') {

      this.blockText = <string>selectedBlock.blockDetails?.textLines?.join("\n")

      if(this.blockText === undefined) {
        this.blockText = ""
      }

      this.textBlockValues = <TextBlockDetails>selectedBlock.blockDetails

      let align = (this.textBlockValues !== null) ? this.textBlockValues.align : 1;
      let fontType = (this.textBlockValues !== null) ? this.textBlockValues.fontType : 1;
      let fontSize  = (this.textBlockValues !== null) ? this.textBlockValues.fontSize : 1;

      let currentBlockDetails = new TextBlockDetails(
        <string[]>selectedBlock.blockDetails?.textFormatting,
        align,
        fontType,
        fontSize,
        []
      );

      this.textBlockValues = currentBlockDetails //<TextBlockDetails>selectedBlock.blockDetails
      this.toggleGr = <string[]>selectedBlock.blockDetails?.textFormatting;
    }

    if (selectedBlock.type === 'image') {
      if(selectedBlock.blockDetails !== null) {
        this.imageBlockValues = <ImageBlockDetails>selectedBlock.blockDetails
      } else {
        this.imageBlockValues = new ImageBlockDetails("", 1, 300, 200);
      }
    }

    if (selectedBlock.type === 'barcode') {
      if(selectedBlock.blockDetails !== null) {
        this.barcodeBlockValues = <BarcodeBlockDetails>selectedBlock.blockDetails
      } else {
        this.barcodeBlockValues = new BarcodeBlockDetails("{voucher-barcode}", "CODE-128", "2", 100, 2, "center");
      }
    }

  }

  boldChanged() {
    //console.log("boldChanged", this.blockValues)
    //console.log("boldChanged fontBoldControl", this.fontBoldControl)
    console.log("boldChanged toggleGr", this.toggleGr)
  }

  italicChanged() {
    //console.log("italicChanged", this.blockValues)
    //console.log("italicChanged fontBoldControl", this.fontBoldControl)
    console.log("italicChanged toggleGr", this.toggleGr)
  }

  uderlineChanged() {
    //console.log("uderlineChanged", this.blockValues)
    //console.log("uderlineChanged fontBoldControl", this.fontBoldControl)
    console.log("uderlineChanged toggleGr", this.toggleGr)
  }

  groupChange() {
    //console.log("uderlineChanged", this.blockValues)
    //console.log("uderlineChanged fontBoldControl", this.fontBoldControl)
    console.log("uderlineChanged toggleGr", this.toggleGr)
  }


  insertVoucherDateCode() {
    this.blockText = this.blockText + "{voucher-generation-date#pattern#}"
  }

  insertVoucherExpirationDate() {
    this.blockText = this.blockText + "{voucher-expiration-date#pattern#}"
  }

  insertSeparatingLine() {
    this.blockText = this.blockText + "{separating-line}"
  }

  insertFillSpace() {
    this.blockText = this.blockText + "{fill-space}"
  }


  insertBottlesCount() {
    this.blockText = this.blockText + "{voucher-number-of-bottles}"
  }

  insertCansCount() {
    this.blockText = this.blockText + "{voucher-number-of-cans}"
  }

  insertVoucherId() {
    this.blockText = this.blockText + "{voucher-id}"
  }

  insertSerialNumber() {
    this.blockText = this.blockText + "{serial-number}"
  }

  insertCurrency() {
    this.blockText = this.blockText + "{currency}"
  }

  insertStreet() {
    this.blockText = this.blockText + "{location-street}"
  }

  insertCity() {
    this.blockText = this.blockText + "{location-city}"
  }

  insertPostCode() {
    this.blockText = this.blockText + "{location-post-code}"
  }  

  insertCountry() {
    this.blockText = this.blockText + "{location-country}"
  }  

  insertCurrretDate() {
    this.blockText = this.blockText + "{current-date#pattern#}"
  }  

  insertVoucherValue() {
    this.blockText = this.blockText + "{voucher-value}"
  }  

  insertPackagesCount() {
    this.blockText = this.blockText + "{voucher-number-of-packages}"
  }  


  blockTextChanged() {
    console.log("blockTextChanged");

    console.log(this.blockText.split("\n"));
  }

}
